import { fetchLesson } from 'actionCreators/lessons';
import { fetchRating } from 'actionCreators/rating';
import { fetchUpsells } from 'actionCreators/upsells';
import { ICourse, ILesson } from 'interface/course';
import { connect } from 'react-redux';
import { IAuth } from 'interface/auth';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { useHistory } from 'react-router-dom';
import { MenuContext } from 'components/Lesson/Modules/menuContext';
import Button from '@material-ui/core/Button';
import ChevronDown from '@eduzz/houston-icons/ChevronDown';
import { useAppSelector } from 'hooks/redux';

interface IProps {
  lesson: ILesson;
  fetchLesson: Function;
  fetchRating: Function;
  selected?: boolean;
  course: ICourse;
  auth: IAuth;
  fetchUpsells: Function;
}

const useStyles = makeStyles((theme) => ({
  lessonCardRoot: {
    background: theme.palette.grey['600'],
    width: '100%',
    cursor: 'pointer',
    '&:hover': {
      '& > div': {
        transform: 'scale(1.03)',
        transition: '0.2s ease-in-out',
      },
    },
  },
  container: {
    borderTop: `1px solid ${theme.palette.safevideo.dark}`,
    '&:last-child': {
      borderBottom: `1px solid ${theme.palette.safevideo.dark}`,
    },
    background: theme.palette.grey['600'],
    display: 'flex',
    flexDirection: 'column',
    padding: 16,
    alignItems: 'flex-end',
  },
  titleAndIcon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 20,
    '& > svg': {
      minWidth: 20,
      minHeight: 20,
      maxWidth: 20,
      marginRight: 20,
      maxHeight: 20,
    },
  },
  lessonTitle: {
    color: theme.palette.common.white,
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 2,
    overflow: 'hidden',
    wordBreak: 'break-word',
  },
  buttonMenu: {
    width: 168,
    height: 24,
    color: theme.palette.primary.light,
    borderColor: theme.palette.primary.light,
    marginTop: 12,
    textTransform: 'initial',
    fontSize: 12,
    '& > span > span': {
      marginLeft: 4,
    },
  },
  watching: {
    background: theme.palette.grey['500'],
  },
}));

const LessonCard = (props: IProps) => {
  const { selected } = props;
  const currentLesson = useAppSelector((state) => state.newLesson.lesson);
  const lesson = selected ? { ...props.lesson, ...currentLesson } : props.lesson;
  const classes = useStyles();
  const history = useHistory();

  const goToLesson = () => {
    history.replace(lesson.id.toString());
  };

  return (
    <MenuContext.Consumer>
      {({ handleOpenMenu }) => {
        return (
          <div className={`${classes.container} ${selected && classes.watching} `}>
            <div
              id={`lesson-${lesson.id}`}
              onClick={goToLesson}
              className={`${classes.lessonCardRoot} ${selected && classes.watching} `}
            >
              <div className={`${classes.titleAndIcon}`}>
                {lesson.watched ? <SvgIcon name='watched-lesson' /> : <SvgIcon name='watch-lesson' />}
                <Typography className={`${classes.lessonTitle}`}>{lesson.title}</Typography>
              </div>
            </div>
            {lesson.has_file && (
              <Button
                id='sidemenu-lesson-files-button'
                variant='outlined'
                className={classes.buttonMenu}
                onClick={(event) => handleOpenMenu(event, lesson.id)}
              >
                Arquivos desta aula <ChevronDown />
              </Button>
            )}
          </div>
        );
      }}
    </MenuContext.Consumer>
  );
};

const mapStateToProps = (state: any, ownProps: any) => ({
  ...ownProps,
  course: state.course,
  auth: state.auth,
});

export default connect(mapStateToProps, { fetchUpsells, fetchLesson, fetchRating })(LessonCard);
